import { render, staticRenderFns } from "./ModalCredit.vue?vue&type=template&id=28503ea7&lang=pug&"
import script from "./ModalCredit.vue?vue&type=script&lang=js&"
export * from "./ModalCredit.vue?vue&type=script&lang=js&"
import style0 from "./ModalCredit.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports